import { render, staticRenderFns } from "./CommonBlock.vue?vue&type=template&id=693007d2"
import script from "./CommonBlock.vue?vue&type=script&lang=js"
export * from "./CommonBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports